// removed by extract-text-webpack-plugin
module.exports = {"plainText":"src-styles----textContent-module---plainText---1tsBR","subTitle":"src-styles----textContent-module---subTitle---9xsnG","bold":"src-styles----textContent-module---bold---32o4w","blueText":"src-styles----textContent-module---blueText---2R81o","comparisonHeader":"src-styles----textContent-module---comparisonHeader---1XwK8","textEditor":"src-styles----textContent-module---textEditor---1t7nn src-styles----textContent-module---plainText---1tsBR"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/textContent.module.styl
// module id = 573
// module chunks = 168707334958949